import { render, staticRenderFns } from "./desempenho-atendentes.vue?vue&type=template&id=514da590&scoped=true"
import script from "./desempenho-atendentes.vue?vue&type=script&lang=js"
export * from "./desempenho-atendentes.vue?vue&type=script&lang=js"
import style0 from "./desempenho-atendentes.vue?vue&type=style&index=0&id=514da590&prod&scoped=true&lang=css"
import style1 from "./desempenho-atendentes.vue?vue&type=style&index=1&id=514da590&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514da590",
  null
  
)

export default component.exports